import { forwardRef } from '@chakra-ui/react';
import {
    UsaRegionCode,
    usaRegionCodes,
    UsaRegionName,
    usaRegionNameByRegionCode,
} from '@common/location';
import React from 'react';
import SelectInput, { SelectInputProps } from './SelectInput';

type UsaStateOption = {
    value: UsaRegionCode;
    label: UsaRegionName;
};

const USA_STATES: UsaStateOption[] = usaRegionCodes.map((code) => ({
    value: code,
    label: usaRegionNameByRegionCode[code],
}));

interface UsaStateInputProps<V = any>
    extends Omit<SelectInputProps<V>, 'value' | 'options'> {
    value: UsaRegionCode;
}

function UsaStateInputInner<V = any>(
    { value, onChange, ...props }: UsaStateInputProps<V>,
    ref: React.ForwardedRef<HTMLSelectElement>
) {
    return (
        <SelectInput
            ref={ref}
            options={USA_STATES}
            value={value}
            onChange={onChange}
            {...props}
        />
    );
}

const UsaStateInput = forwardRef<UsaStateInputProps, 'select'>(
    UsaStateInputInner
);

export default UsaStateInput;
